import { getQueryStringFromUrl } from './getQueryStringFromUrl'

export const getCurrentQuery = () => getQueryStringFromUrl(window.location.href)
